import { useTranslation } from 'react-i18next'
import { Button, EmptyState } from '@/ds'
import type { CaptureErrorCode } from '@/services/checkin/capture'

const QR = 'v2.legacy.stepper.collectDataForm.miDniQr'
const AUTO = 'v2.legacy.stepper.autoCollect.errors'

/** Errores de captura con los textos de la app actual (autoCollect.errors y miDniQr.errors). */
export function CaptureErrorState({ code, qr, onRetry, onManual }: { code: CaptureErrorCode; qr: boolean; onRetry: (() => void) | null; onManual: (() => void) | null }) {
  const { t } = useTranslation()
  let title: string
  let text: string
  switch (code) {
    case 'unreadable':
      title = t(`${AUTO}.scanFailed.title`)
      text = t(`${AUTO}.scanFailed.description`)
      break
    case 'no_camera':
      title = qr ? t(`${QR}.errorTitle`) : t(`${AUTO}.noCameraAccess.title`)
      text = qr ? t(`${QR}.errors.permissionDenied`) : t(`${AUTO}.noCameraAccess.description`)
      break
    case 'insecure':
      title = t(`${QR}.errorTitle`)
      text = t(`${QR}.errors.insecureContext`)
      break
    case 'camera_unavailable':
      title = t(`${QR}.errorTitle`)
      text = t(`${QR}.errors.cameraUnavailable`)
      break
    case 'camera':
      title = t(`${QR}.errorTitle`)
      text = t(`${QR}.errors.camera`)
      break
    default:
      title = t('v2.legacy.error.anErrorHasOcurred')
      text = t('v2.legacy.error.tryAgainOrContactUs')
  }
  return (
    <div className="checkin__stack">
      <EmptyState tone="error" icon={code === 'no_camera' || code === 'camera_unavailable' || code === 'camera' ? 'camera' : 'alert-triangle'} title={title} {...(onRetry && code !== 'insecure' ? { onAction: onRetry, actionLabel: t(`${QR}.retry`) } : {})}>
        {text}
      </EmptyState>
      {onManual && (
        <Button variant="secondary" onClick={onManual}>
          {t('v2.checkin.documento.aMano')}
        </Button>
      )}
    </div>
  )
}
